<template>
  <Transition
    enter-active-class="transition-all duration-500 ease-out"
    enter-from-class="translate-y-full opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition-all duration-300 ease-in"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-full opacity-0"
  >
    <div
      v-if="showNotice"
      class="fixed cookie bottom-[84px] left-5 right-5 z-50 max-w-lg rounded-xl bg-white/90 p-4 shadow-2xl outline outline-2 outline-black-100 backdrop-blur-lg dark:bg-primary-1000/50 dark:outline-primary-700 max-md:max-w-none md:bottom-6"
    >
      <div class="flex items-start gap-3">
        <div class="flex flex-1 flex-col">
          <p
            class="max-w-lg text-sm leading-relaxed text-primary-1000 dark:text-white"
          >
            Информируем вас о том, что данный ресурс использует <b>cookie</b>,
            сервисы веб-аналитики. Продолжая пользоваться им, вы соглашаетесь с
            использованием
            <b>cookie</b>
            для улучшения работы сайта.
          </p>

          <Button
            @click="acceptCookies"
            title="Принять и закрыть"
            class="mt-4 inline-block"
          />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { watchOnce } from '@vueuse/core'
import { useCookies } from '@vueuse/integrations/useCookies'
import { onMounted, ref, watch } from 'vue'

import { useAuthStore } from '@/store/auth'

import Button from '@/components/ui/UIButton.vue'

const showNotice = ref(false)
const COOKIE_NAME = 'cookie-consent'
const COOKIE_VALUE = 'accepted'

const cookies = useCookies([COOKIE_NAME])
const auth = useAuthStore()

const checkCookieConsent = () => {
  if (auth.user) {
    acceptCookies()
    return true
  }

  return cookies.get(COOKIE_NAME) === COOKIE_VALUE
}

const acceptCookies = () => {
  cookies.set(COOKIE_NAME, COOKIE_VALUE, {
    maxAge: 60 * 60 * 24 * 365, // 1 year
  })

  showNotice.value = false
}

function tryShowNotice() {
  if (!auth.loading.user) {
    setTimeout(() => {
      if (!checkCookieConsent()) {
        showNotice.value = true
      }
    }, 3000)
  }
}

// wait for auth
watchOnce(
  () => auth.loading.user,
  () => {
    tryShowNotice()
  },
)

onMounted(() => {
  tryShowNotice()
})
</script>
